import { Box, Group } from "@mantine/core";
import { NavLink } from "react-router-dom";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { getSpacing, spacing } from "#app/theme/v2/spacing";
import { Text } from "#components/atoms/Typographies/Text";

import classes from "./NavItem.module.css";

type NavItemProps = {
  icon: React.ReactNode;
  label: string;
  to: string;
  disabled?: boolean;
};

export const NAV_ITEM_ICON_SIZE = getSpacing(4);

const NavItem = ({ icon, label, to, disabled }: NavItemProps) => {
  return (
    <NavLink to={to} className={classes.link} onClick={(e) => disabled && e.preventDefault()}>
      {({ isActive }) => (
        <Group
          gap={spacing[2.5]}
          wrap="nowrap"
          className={classes.item}
          aria-disabled={disabled}
          style={{
            padding: `${spacing[1.5]} ${spacing[4]}`,
            borderRadius: radius.lg,
            backgroundColor: isActive
              ? colors.bg.button.custom.pressed
              : colors.bg.button.custom.default,
            "--nav-hover-bg": colors.bg.button.custom.hover,
            pointerEvents: disabled ? "none" : "auto",
            opacity: disabled ? 0.5 : 1,
          }}
        >
          <Box
            style={{
              color: isActive ? colors.icon.primaryDefault : colors.icon.secondary,
              display: "flex",
              alignItems: "center",
              flexShrink: 0,
            }}
          >
            {icon}
          </Box>
          <Text
            size="small"
            type="medium"
            color={isActive ? colors.text.navHover : colors.text.navDefault}
            truncate
          >
            {label}
          </Text>
        </Group>
      )}
    </NavLink>
  );
};

export { NavItem };
